<template>
  <v-card id="address" flat class="secondary">
    <span class="px-2 mx-1">
      <b>
        {{ title }}
      </b>
    </span>
    <NameAutoComplete
      :addressType="addressType"
      :id="nameId"
      label="Navn"
      :disabled="!addressEditable"
      :clearable="true"
      :required="true"
      :rules="nameRules"
      class="pt-2 pb-2"
      @forceFocus="forceFocus()"
      @selected="loadMatchingTerminalAddress($event)"
    />
    <AddressAutoComplete
      ref="addressAutocomplete"
      :addressType="addressType"
      :id="addressId"
      :label="addressLabel"
      :disabled="!addressEditable"
      :clearable="true"
      :required="true"
      :rules="addressRules()"
      class="pb-2"
      @selected="addressSelected($event)"
      @cleared="clearAddress()"
    />
    <v-row no-gutters style="margin-bottom:-10px">
      <v-text-field
        v-model="address2"
        label="Adresseinfo"
        :id="address2Id"
        :disabled="!contactInfoEditable"
        clearable
        outlined
        dense
        color="primary"
        background-color="white"
        class="pb-2 mx-2"
      ></v-text-field>
    </v-row>
    <v-row no-gutters style="margin-bottom:-10px">
      <v-text-field
        v-if="contactVisible"
        v-model="contactName"
        label="Kontaktperson"
        :id="contactNameId"
        :disabled="!contactInfoEditable"
        :required="!allowEmptyContactPerson"
        :rules="!allowEmptyContactPerson ? contactPersonRules : []"
        clearable
        outlined
        dense
        color="primary"
        background-color="white"
        class="pt-0 pb-2 mx-2"
      ></v-text-field>
    </v-row>
    <v-row no-gutters style="margin-bottom:-10px">
      <v-text-field
        v-if="contactVisible"
        v-model="contactPhone"
        label="Kontakttlf."
        :id="contactPhoneId"
        :disabled="!contactInfoEditable"
        :required="!allowEmptyContactPhone"
        :rules="!allowEmptyContactPhone ? contactPhoneRules : []"
        clearable
        outlined
        dense
        color="primary"
        background-color="white"
        class="pb-2 mx-2"
      ></v-text-field>
    </v-row>
  </v-card>
</template>

<script>
import NameAutoComplete from "@/components/inputs/NameAutoComplete.vue";
import AddressAutoComplete from "@/components/inputs/AddressAutoComplete.vue";
import { dictionary } from "../helpers";

export default {
  name: "Address",
  components: {
    NameAutoComplete,
    AddressAutoComplete
  },
  created() {
    this.addressInfoVisible = !this.$store.getters["user/hideAddressInfo"];
    this.contactVisible = !this.$store.getters["user/hideContact"];
    this.allowEmptyContactPerson = this.$store.getters[
      "user/allowEmptyContactPerson"
    ];
    this.allowEmptyContactPhone = this.$store.getters[
      "user/allowEmptyContactPhone"
    ];
    const useOwnAddressAs = this.$store.getters["user/useOwnAddressAs"];
    const ownAddressEditable = this.$store.getters["user/ownAddressEditable"];

    if (this.addressType === dictionary.constants.address_types.pickup) {
      this.title = "Afhentning";
      this.addressId = "pickupAddress";
      this.nameId = "pickupName";
      this.address2Id = "pickupAddress2";
      this.contactNameId = "pickupContactName";
      this.contactPhoneId = "pickupContactPhone";

      this.addressEditable =
        !useOwnAddressAs ||
        useOwnAddressAs === dictionary.constants.address_types.delivery ||
        ownAddressEditable;
    } else if (
      this.addressType === dictionary.constants.address_types.delivery
    ) {
      this.title = "Levering";
      this.addressId = "deliveryAddress";
      this.nameId = "deliveryName";
      this.address2Id = "deliveryAddress2";
      this.contactNameId = "deliveryContactName";
      this.contactPhoneId = "deliveryContactPhone";

      this.addressEditable =
        !useOwnAddressAs ||
        useOwnAddressAs === dictionary.constants.address_types.pickup ||
        ownAddressEditable;
    }

    this.contactInfoEditable =
      this.addressEditable ||
      this.$store.getters["user/bookingType"] ==
        dictionary.constants.booking_types.courier;
  },
  props: ["addressType"],
  data: () => ({
    forceRenderName: true,
    title: "",
    addressId: "",
    addressLabel: "Adresse",
    addressEditable: true,
    contactInfoEditable: true,
    // addressRules: [v => (!!v && validateCoordinates()) || false],
    nameId: "",
    nameRules: [v => !!v || false],
    addressInfoVisible: true,
    address2Id: "",
    displayContactInfo: false,
    allowEmptyContactPerson: true,
    allowEmptyContactPhone: true,
    openDisplayIcon: dictionary.mdi.open,
    closeDisplayIcon: dictionary.mdi.close,
    contactVisible: true,
    contactNameId: "",
    contactPhoneId: "",
    contactPersonRules: [v => !!v || false],
    contactPhoneRules: [v => !!v || false]
  }),
  computed: {
    name: {
      get() {
        if (this.addressType === dictionary.constants.address_types.pickup) {
          return this.$store.state.booking.data.pickup.address.name;
        }
        if (this.addressType === dictionary.constants.address_types.delivery) {
          return this.$store.state.booking.data.delivery.address.name;
        }
        return null;
      },
      set(value) {
        if (this.addressType === dictionary.constants.address_types.pickup) {
          this.$store.commit("booking/updatePickupName", value);
        }
        if (this.addressType === dictionary.constants.address_types.delivery) {
          this.$store.commit("booking/updateDeliveryName", value);
        }
      }
    },
    address2: {
      get() {
        if (this.addressType === dictionary.constants.address_types.pickup) {
          return this.$store.state.booking.data.pickup.address.address2;
        }
        if (this.addressType === dictionary.constants.address_types.delivery) {
          return this.$store.state.booking.data.delivery.address.address2;
        }
        return null;
      },
      set(value) {
        if (this.addressType === dictionary.constants.address_types.pickup) {
          this.$store.commit("booking/updatePickupAddress2", value);
        }
        if (this.addressType === dictionary.constants.address_types.delivery) {
          this.$store.commit("booking/updateDeliveryAddress2", value);
        }
      }
    },
    contactName: {
      get() {
        if (this.addressType === dictionary.constants.address_types.pickup) {
          return this.$store.state.booking.data.pickup.contact.name;
        }
        if (this.addressType === dictionary.constants.address_types.delivery) {
          return this.$store.state.booking.data.delivery.contact.name;
        }
        return null;
      },
      set(value) {
        if (this.addressType === dictionary.constants.address_types.pickup) {
          this.$store.commit("booking/updatePickupContactName", value);
        }
        if (this.addressType === dictionary.constants.address_types.delivery) {
          this.$store.commit("booking/updateDeliveryContactName", value);
        }
      }
    },
    contactPhone: {
      get() {
        if (this.addressType === dictionary.constants.address_types.pickup) {
          return this.$store.state.booking.data.pickup.contact.phone;
        }
        if (this.addressType === dictionary.constants.address_types.delivery) {
          return this.$store.state.booking.data.delivery.contact.phone;
        }
        return null;
      },
      set(value) {
        if (this.addressType === dictionary.constants.address_types.pickup) {
          this.$store.commit("booking/updatePickupContactPhone", value);
        }
        if (this.addressType === dictionary.constants.address_types.delivery) {
          this.$store.commit("booking/updateDeliveryContactPhone", value);
        }
      }
    }
  },
  watch: {
    name: {
      deep: true,
      handler() {
        this.forceRenderName = false;

        this.$nextTick(() => {
          // add my-component component in DOM
          this.forceRenderName = true;
        });
      }
    }
  },
  methods: {
    addressRules() {
      return [
        v => !!v || false,
        v => {
          v;
          if (this.addressType === dictionary.constants.address_types.pickup) {
            return this.$store.getters["booking/validatePickupCoordinates"];
          } else if (
            this.addressType === dictionary.constants.address_types.delivery
          ) {
            return this.$store.getters["booking/validateDeliveryCoordinates"];
          }
          return false;
        }
      ];
    },
    addressSelected(address) {
      if (address && address.service) {
        let addressObj;
        const currentAddress =
          this.addressType === dictionary.constants.address_types.pickup
            ? this.$store.state.booking.data.pickup.address
            : this.$store.state.booking.data.delivery.address;

        if (
          address.service === dictionary.constants.autocomplete_services.DAWA
        ) {
          const addressString =
            address.vejnavn +
            " " +
            address.husnr +
            (address.etage ? ", " + address.etage + "." : "") +
            (address.dør ? " " + address.dør : "");

          addressObj = {
            name: currentAddress.name,
            address: addressString,
            zip: address.postnr,
            city: address.postnrnavn,
            country: currentAddress.country,
            lat: address.y + "",
            lon: address.x + "" //force coordinates as string
          };
        }

        if (
          address.service ===
          dictionary.constants.autocomplete_services.GoogleMaps
        ) {
          const addressString =
            address.route +
            (address.street_number
              ? " " +
                address.street_number +
                (address.floor ? ", " + address.floor + "." : "")
              : ""); // + (address.dør ? ' ' + address.dør : '')

          addressObj = {
            name: currentAddress.name,
            address: addressString || address.formatted_address || address.name,
            zip: address.postal_code ? address.postal_code : "",
            city: address.locality
              ? address.locality
              : address.administrative_area_level_2 ||
                address.administrative_area_level_1 ||
                "",
            country: currentAddress.country,
            lat: address.latitude ? address.latitude + "" : "",
            lon: address.longitude ? address.longitude + "" : "" //force coordinates as string
          };
        }

        if (addressObj) {
          if (this.addressType === dictionary.constants.address_types.pickup) {
            this.$store.commit("booking/updatePickupAddress", addressObj);

            this.loadMatchingTerminalAddress(addressObj);
          }
          if (
            this.addressType === dictionary.constants.address_types.delivery
          ) {
            this.$store.commit("booking/updateDeliveryAddress", addressObj);
          }

          this.$nextTick(() => {
            if (this.$refs.addressAutocomplete) {
              this.$refs.addressAutocomplete.resetValidation();
            }
          });
        }
      }
    },
    loadMatchingTerminalAddress(addressObj) {
      if (
        addressObj &&
        this.$store.state.user.activeUser.settings.find(
          setting => setting.type === dictionary.settings.booking_type
        ).value === dictionary.constants.booking_types.distribution
      ) {
        //if distribution booking; only pickup is editabel and must load matching terminal address for delivery.
        const customerId = this.$store.state.booking.data.account.id;
        const inboundOutboundType =
          dictionary.constants.terminal_address_types.inbound;
        this.$store.dispatch("booking/loadMatchingTerminalAddress", {
          customerId,
          inboundOutboundType,
          address: addressObj
        });
      }
    },
    clearAddress() {
      if (this.addressType === dictionary.constants.address_types.pickup) {
        this.$store.commit("booking/clearPickupAddress");
      } else if (
        this.addressType === dictionary.constants.address_types.delivery
      ) {
        this.$store.commit("booking/clearDeliveryAddress");
      }
    },
    forceFocus() {
      this.$emit("forceFocus");
    }
  }
};
</script>
